define([
    "jquery",
    "underscore",
    "marionette",
    "models/demo_member_model",
    "behaviors/form_errors_behavior",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, DemoMember, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'country': '#country_abbr',
            'accountType': '#account_type',
            'submitBtn': '#submit',
            'form': '#demo_account_form',
            'captchaImage': '#captcha_image'
        },

        events:{
            'change @ui.country': 'setAccountTypeAndCurrency',
            'change @ui.accountType': 'setCurrency',
            'click @ui.submitBtn': 'submit'
        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();
            this.setAccountTypeAndCurrency();
            
            this.model = new DemoMember();
        },

        setCurrency: function() {
            var demoGroupsOfCountryAndAccountType = _.where( demoGroups, { country_abbr : this.$('#country_abbr').val(), account_type : this.$('#account_type').val()});
            if( demoGroupsOfCountryAndAccountType.length === 0)
                demoGroupsOfCountryAndAccountType = _.where( demoGroups, { country_abbr : null, account_type : this.$('#account_type').val()});

            var currencies = _.pluck( demoGroupsOfCountryAndAccountType, 'currency_abbr');
            currencies = _.uniq( currencies);
            var that = this;
            this.$('#currency_abbr').empty();
            _.each( currencies, function( currency) {
                that.$('#currency_abbr').append( "<option value='" + currency + "'>" + currency + "</option>");
            });
        },

        setAccountTypeAndCurrency: function() {
            var demoGroupsOfCountry = _.where( demoGroups, { country_abbr : this.$('#country_abbr').val()});
            if( demoGroupsOfCountry.length === 0)
                demoGroupsOfCountry = _.where( demoGroups, { country_abbr : null});

            var accountTypesOfCountry = _.pluck( demoGroupsOfCountry, 'account_type');
            accountTypesOfCountry = _.uniq( accountTypesOfCountry);
            var that = this;
            this.$('#account_type').empty();
            _.each( accountTypesOfCountry, function( accountType) {
                that.$('#account_type').append( "<option value='" + accountType + "'>" + accountType + "</option>");
            });

            this.setCurrency();
        },
                
        submit: function(e){
            var that = this;
            if(e) e.preventDefault();

            var formData = Backbone.Syphon.serialize(this);

            this.model.set(formData);

            if(this.captchaCheck){
                this.model.set('captcha_check', this.captchaCheck);
            }

            var errors = this.model.validate();

            if(!formData['captcha_code']){
                errors = _.extend({}, errors, {captcha_code: 'You must complete the captcha.'});
            }

            if(_.size(errors) < 1){
                HoldOn.open({
                    theme:"sk-fading-circle"
                });
                this.model.save(null, {
                    type: 'POST',
                    success: function(model, res){
                        that.ui.form[0].reset();
                        that.ui.captchaImage.attr('src', '/common/show_captcha');
                        that.triggerMethod('show:success');
                    },
                    error: function(model, error){
                        if(error.responseJSON.captcha_check){
                            that.captchaCheck = error.responseJSON.captcha_check;
                        }
                        delete error.responseJSON.captcha_check;
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                }).always(function(){
                    HoldOn.close();
                });
            }else{
                this.triggerMethod('show:errors', errors);
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/open_account/demo_account_view.js
// module id = 25
// module chunks = 0